import { faCalendar, faClock, faLocationDot } from '@fortawesome/pro-regular-svg-icons';
import { useQuery } from '@apollo/client';

import cx from '@/lib/cx';
import { gql } from '@/generated';
import { useCampaignPage } from '@/context/CampaignPage';
import { formatDateRange, formatAddress } from '@/lib/formatters';
import Card from '@/components/common/Card';
import CampaignPageFundraiserStatLine from './CampaignPageFundraiserStatLine';

const GET_EVENT = gql(/* GraphQL */ `
  query GetEventDetails($id: String!) {
    findCampaigns(id: $id) {
      id
      activeFeatures {
        event
      }
      event {
        id
        startDate
        endDate
        time

        address1
        address2
        city
        stateProv
        country
        postalCode
      }
    }
  }
`);

const CampaignPageFundraiserEventDetails = ({ className }: { className?: string }) => {
  const { campaignId } = useCampaignPage();
  const { data } = useQuery(GET_EVENT, {
    variables: { id: campaignId },
  });

  const campaign = data?.findCampaigns?.[0];
  const event = campaign?.event;
  const isEvent = campaign?.activeFeatures.event;

  const fullAddress = formatAddress({
    address1: event?.address1,
    address2: event?.address2,
    city: event?.city,
    stateProv: event?.stateProv,
    country: event?.country,
    postalCode: event?.postalCode,
  });

  if (!isEvent || !event) return null;

  return (
    <Card depth="none" className={cx('border border-gray-300', className)}>
      <h2 className="text-xl font-medium mb-8">About the Event</h2>
      <Card depth="none" padding="xs" border>
        <div className="grid grid-cols-1 gap-y-5">
          <CampaignPageFundraiserStatLine
            icon={faCalendar}
            iconClassName="text-xl text-teal-500"
            label={formatDateRange(event.startDate, event.endDate)}
          />
          {event.time && (
            <CampaignPageFundraiserStatLine
              icon={faClock}
              iconClassName="text-xl text-teal-500"
              label={event.time}
            />
          )}
          {fullAddress.length > 0 && (
            <CampaignPageFundraiserStatLine
              icon={faLocationDot}
              iconClassName="text-xl text-teal-500"
              label={fullAddress}
            />
          )}
        </div>
      </Card>
    </Card>
  );
};

export default CampaignPageFundraiserEventDetails;
